import { render, staticRenderFns } from "./instockSetting.vue?vue&type=template&id=3f03eb4a&scoped=true&"
import script from "./instockSetting.vue?vue&type=script&lang=js&"
export * from "./instockSetting.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f03eb4a",
  null
  
)

export default component.exports